/**
 * Hot Work Checklist
 * Welding, cutting, grinding
 * Regulatory: COSWP, Company SMS
 */

export const HOT_WORK_CHECKLIST = {
  id: 'hot_work',
  name: 'Hot Work',
  description: 'Welding, cutting, grinding',
  icon: 'Flame',
  regulatory: 'COSWP, Company SMS',
  isCustomisable: true,
  items: [
    { id: 'hw_1', text: 'Hot work permit issued', required: true },
    { id: 'hw_2', text: 'Area cleared of combustibles', required: true },
    { id: 'hw_3', text: 'Fire extinguisher at work site', required: true },
    { id: 'hw_4', text: 'Fire watch posted', required: true },
    { id: 'hw_5', text: 'Adjacent spaces checked (other side of bulkhead)', required: true },
    { id: 'hw_6', text: 'Ventilation adequate', required: true },
    { id: 'hw_7', text: 'Fire watch maintained 30 mins after completion', required: true }
  ]
};
